import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "@/components/Card";
import { Navigation, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import CustomSlider from "@/components/CustomSlider";
import { homeSection9Arr } from "@/utils/StringUtils";
import Footer from "@/layout/Footer";
const Home = () => {
	const homeSection7Cards = [
		{
			imageSrc: "/assets/home/section7/card1.png",
			imageAlt: "Section7 Card1",
			logoPath: "/assets/home/section7/logo.png",
			logoAlt: "Section7 Card1 3rd Main Div",
			mainText: "I struggled with lack of market insights",
			authorName: "Oliver. O -",
			descriptionText:
				"Tracking customer demand and finding trending products took away a huge chunk of my time. Now, with Rbetraj's automated and real-time insights, I am able to quickly choose products that have the most likelihood of earning me profits.",
			starIconPath: "/assets/home/section7/star2.png",
		},
		{
			imageSrc: "/assets/home/section7/card2.png",
			imageAlt: "Section7 Card2",
			logoPath: "/assets/home/section7/logo.png",
			logoAlt: "Section7 Card2 3rd Main Div",
			mainText: "Product research was my biggest challenge",
			authorName: "Sarah. M -",
			descriptionText:
				"Finding winning products used to take me hours of manual research. With Rbetraj's AI-powered recommendations, I can now identify profitable products in minutes and focus more on growing my business.",
			starIconPath: "/assets/home/section7/star2.png",
		},
		{
			imageSrc: "/assets/home/section7/card3.png",
			imageAlt: "Section7 Card3",
			logoPath: "/assets/home/section7/logo.png",
			logoAlt: "Section7 Card3 3rd Main Div",
			mainText: "Pricing strategy made simple",
			authorName: "James. T -",
			descriptionText:
				"Determining the right price for my products was always guesswork. Rbetraj's competitive pricing analysis helps me set optimal prices that maximize both sales and profits.",
			starIconPath: "/assets/home/section7/star2.png",
		},
		{
			imageSrc: "/assets/home/section7/card1.png",
			imageAlt: "Section7 Card4",
			logoPath: "/assets/home/section7/logo.png",
			logoAlt: "Section7 Card4 3rd Main Div",
			mainText: "Saved hours of manual work",
			authorName: "Emma. L -",
			descriptionText:
				"The automation features have transformed my workflow. What used to take me 5-6 hours daily now happens automatically, giving me time to focus on strategy and customer service.",
			starIconPath: "/assets/home/section7/star2.png",
		},
	];

	const homeSection8MobileCards = [
		{
			imageSrc: "/assets/home/section8/card1.svg",
			imageAlt: "Section8Mobile Card1",
			title: "Unleashing Potential: A Trail...",
			description:
				"In the dynamic world of e-commerce, taking opportunities and optimizing operations are essential for success....",
			clockIcon: "/assets/home/section8/cardBottomClock.svg",
			readTime: "	4 min read time",
		},
		{
			imageSrc: "/assets/home/section8/card2.svg",
			imageAlt: "Section8Mobile Card2",
			title: "Unleashing Potential: A Trail...",
			description:
				"In the dynamic world of e-commerce, taking opportunities and optimizing operations are essential for success....",
			clockIcon: "/assets/home/section8/cardBottomClock.svg",
			readTime: "	4 min read time",
		},
		{
			imageSrc: "/assets/home/section8/card3.svg",
			imageAlt: "Section8Mobile Card3",
			title: "Unleashing Potential: A Trail...",
			description:
				"In the dynamic world of e-commerce, taking opportunities and optimizing operations are essential for success....",
			clockIcon: "/assets/home/section8/cardBottomClock.svg",
			readTime: "	4 min read time",
		},
	];

	const productCards = [
		{
			id: 1,
			image: "/assets/home/section3/card1.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/home/section3/card2.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 3,
			image: "/assets/home/section3/card3.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 4,
			image: "/assets/home/section3/card1.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
	];

	const marketplaceLogos = [
		"Alibaba.png",
		"Walmart.png",
		"AliExpress.png",
		"Amazon.png",
		"Ebay.png",
		"AliExpress.png",
		"Amazon.png",
		"Ebay.png",
	];

	const featureCardsRow1 = [
		{
			image: "/assets/home/section4/features/shop1.png",
			title: "Profit-Driven \n Product Research",
			description:
				"Instantly find high-profit products for your niche from global suppliers with Rbetrage’s Dropshipping Automation Software.",
		},
		{
			image: "/assets/home/section4/features/real-time.png",
			title: "Real-Time \n Price Comparison",
			description:
				"Make use of Rbetraj’s real-time price comparison tool to increase margins and maintain your competitive edge in the dropshipping industry.",
		},
		{
			image: "/assets/home/section4/features/effortLessUser.png",
			title: "Effortless User \n Experience",
			description:
				"Take advantage of a user-friendly interface that makes product research for dropshipping a breeze.",
		},
	];

	const featureCardsRow2 = [
		{
			image: "/assets/home/section4/features/data_transparency.png",
			title: "Data\nTransparency",
			description:
				"Rbetrage’s Dropshipping tool provides complete data transparency, allowing you to optimize your product sourcing strategy.",
		},
		{
			image: "/assets/home/section4/features/powerful_product.png",
			title: "Powerful Product\nResearch Tools",
			description:
				"Find millions of trending products from trusted and reliable global suppliers, such as AliExpress, Amazon, eBay, Walmart, Etsy and many more.",
		},
		{
			image: "/assets/home/section4/features/pig.png",
			title: "Profit\nDashboard",
			description:
				"Get clear insights into your store’s performance and measure the success of your product sales.",
		},
	];

	const categoriesCardRow1 = [
		{
			image: "/assets/home/section6/watch.png",
			title: "Electronic Devices",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/electric_tools.png",
			title: "Electronic Tools",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/gifts.png",
			title: "Gifts",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/hardware.png",
			title: "Hardware",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/health_beauty.png",
			title: "Health & Beauty",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/home_garden.png",
			title: "Home & Garden",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
	];

	const categoriesCardRow2 = [
		{
			image: "/assets/home/section6/health_beauty.png",
			title: "Health & Beauty",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/home_garden.png",
			title: "Home & Garden",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/luggage_bags.png",
			title: "Luggage & Bags",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/office_supplies.png",
			title: "Office Supplies",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/watch.png",
			title: "Electronic Devices",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/electric_tools.png",
			title: "Electronic Tools",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
	];

	const faqCardsRow1 = [
		{
			icon: "/assets/home/section11/faq.png",
			category: "FAQ",
			question: "Which are the best Dropshipping suppliers?",
			answerPreview:
				"There are many trustworthy and reliable suppliers in the market. T....",
			readTimeIcon: "/assets/home/section11/clock.png",
			readTime: "9 minutes",
			backgroundColor: "bg-[#D2DCD1]",
		},
		{
			icon: "/assets/home/section11/faq.png",
			category: "FAQ",
			question: "Which are the best Dropshipping suppliers?",
			answerPreview:
				"There are many trustworthy and reliable suppliers in the market. T....",
			readTimeIcon: "/assets/home/section11/clock.png",
			readTime: "9 minutes",
			backgroundColor: "bg-[#D2DCD1]",
		},
		{
			icon: "/assets/home/section11/faq.png",
			category: "FAQ",
			question: "Which are the best Dropshipping suppliers?",
			answerPreview:
				"There are many trustworthy and reliable suppliers in the market. T....",
			readTimeIcon: "/assets/home/section11/clock.png",
			readTime: "9 minutes",
			backgroundColor: "bg-[#D2DCD1]",
		},
	];

	const faqCardsRow2 = [
		{
			icon: "/assets/home/section11/faq.png",
			category: "FAQ",
			question: "Which are the best Dropshipping suppliers?",
			answerPreview:
				"There are many trustworthy and reliable suppliers in the market. T....",
			readTimeIcon: "/assets/home/section11/clock.png",
			readTime: "9 minutes",
			backgroundColor: "bg-[#D2DCD1]",
		},
		{
			icon: "/assets/home/section11/faq.png",
			category: "FAQ",
			question: "Which are the best Dropshipping suppliers?",
			answerPreview:
				"There are many trustworthy and reliable suppliers in the market. T....",
			readTimeIcon: "/assets/home/section11/clock.png",
			readTime: "9 minutes",
			backgroundColor: "bg-[#D2DCD1]",
		},
		{
			icon: "/assets/home/section11/faq.png",
			category: "FAQ",
			question: "Which are the best Dropshipping suppliers?",
			answerPreview:
				"There are many trustworthy and reliable suppliers in the market. T....",
			readTimeIcon: "/assets/home/section11/clock.png",
			readTime: "9 minutes",
			backgroundColor: "bg-[#657D77]",
			textColor: "#fffff",
		},
	];

	return (
		<>
			{/***Desktop Screen */}

			{/***Section1 Start */}

			<div className="relative w-full  overflow-hidden hidden exact-1024:block above-1024:block">
				{/* Background Image */}
				<div className="absolute right-0  z-[-1] w-full sm:w-auto">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section1/bannerBackground.svg"
						alt="Background Section1"
						className="w-full sm:w-auto h-auto object-cover lg:w-[440px]"
					/>
				</div>

				{/* Base Headline Section */}
				<div className="relative w-full min-h-[700px] flex flex-col sm:flex-row justify-between items-center px-6 sm:px-[72px] py-10 mt-4">
					{/* Left Side (Text & Button) */}
					<div className="w-full sm:w-[579px] flex flex-col text-center sm:text-left items-center sm:items-start gap-6">
						{/* Headline Section */}
						<h1 className="text-[32px] leading-[40px] font-semibold font-[Montserrat] text-textPrimary text-left w-full">
							Maximize your Profits with <br />
							<span className="text-textSecondary">
								Rbetraj’s Dropshipping Automation
							</span>
							&nbsp;
							<span className="text-textPrimary">Software</span>
						</h1>

						{/* Description Section */}
						<p className="text-[16px] sm:text-[18px] leading-[26px] sm:leading-[28px] font-medium font-[Montserrat] text-textPrimary">
							Rbetraj’s AI-powered Dropshipping Automation Software is a
							powerful tool that quickly helps you find the most trending
							dropshipping products across major suppliers. It’s intuitive and
							advanced filtering options ensure you grab the best deals and earn
							more profit.
						</p>

						{/* Button */}
						<Link to="/sign-up">
							<button className="w-[167px] h-[44px] rounded-[24px] bg-primary font-montserrat font-button text-button leading-[24px] tracking-button text-center align-middle">
								Start For Free
							</button>
						</Link>
					</div>

					{/* Right Side (Image) */}
					<div className="w-full sm:w-auto flex justify-center sm:justify-end mt-6 sm:mt-0">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section1/banner.svg"
							alt="CircularSectionDesktop"
							className="w-[300px] sm:w-[540px] h-[300px] sm:h-[540px] rounded-full max-w-full "
						/>
					</div>
				</div>
			</div>

			{/***Section1 End */}

			{/***Section2 Start */}

			<div
				className="absolute w-full h-[185px] top-[952px] flex flex-col items-center gap-[32px] px-144px
             hidden above-1024:flex exact-1024:block overflow-hidden"
			>
				{/* Title & Description Container */}
				<div className="w-[1110px] h-[96px] flex flex-col items-center gap-[8px]">
					{/* Title Section */}
					<div className="w-[1110px] h-[32px] text-[32px] leading-[32px] font-semibold font-[Montserrat] text-center">
						<span className="text-[#193D34]">Our Marketplaces</span>
					</div>
					{/* Description Section */}
					<div className="w-[692px] h-[56px] text-[18px] leading-[28px] font-medium font-[Montserrat] text-center">
						<span className="text-[#193D34]">
							Discover Trending Dropshipping Products From Trustworthy Stores
							Across the Globe by Using the Best Dropshipping Product Research
							Software.
						</span>
					</div>
				</div>

				<div className="relative w-full h-auto flex items-center justify-center exact-1024:mt-5  px-4 lg:px-10 2xl:px-20">
					{/* Custom Navigation Buttons */}
					<button className="swiper-button-prev custom-nav-button"></button>

					<Swiper
						modules={[Navigation]}
						centeredSlides={true}
						navigation={{
							prevEl: ".swiper-button-prev",
							nextEl: ".swiper-button-next",
						}}
						breakpoints={{
							1024: { slidesPerView: 3, spaceBetween: 8 },
							1920: { slidesPerView: 5, spaceBetween: 18 },
						}}
						className="mySwiper w-full"
					>
						{marketplaceLogos.map((icon, index) => (
							<SwiperSlide
								key={index}
								className="flex justify-center items-center"
							>
								<img
									loading="lazy"
									decoding="async"
									src={`/assets/home/section2/slide/${icon}`}
									alt={icon.split(".")[0]}
									className="w-[100px] h-[57px] object-contain"
								/>
							</SwiperSlide>
						))}
					</Swiper>

					<button className="swiper-button-next custom-nav-button"></button>
				</div>
			</div>

			{/***Section2 End */}

			{/***Section3 Start */}

			<div
				className="absolute w-full h-[700px] bg-[#CFE6A2] flex flex-col items-center top-[1278px] 
            justify-center hidden above-1024:flex exact-1024:block  exact-1024:overflow-hidden"
			>
				{/* Wrapper for Title and Swiper */}
				<div className="w-full max-w-[1256px] flex flex-col items-center">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[28px] font-semibold leading-[32px] font-[Montserrat] mb-6">
						Most Loved Products This Month
					</div>

					{/* CustomSlider */}
					<div className="w-full">
						<CustomSlider
							type="home"
							cards={productCards}
							cardsToShow={3}
							CardComponent={Card}
						/>
					</div>
				</div>
			</div>

			{/***Section3 End */}

			{/***Section4 Start */}

			<div
				className="absolute w-full h-[926px] top-[2057.51px] pt-5 pb-5 flex flex-col items-center space-y-16
             hidden above-1024:flex exact-1024:block exact-1024:overflow-hidden  exact-1024:space-y-8 exact-1024:h-auto exact-1024:pt-4 exact-1024:pb-8"
			>
				{/* Title Section */}
				<div className="w-full h-[128px] flex flex-col items-center gap-2 bg-white p-4 exact-1024:h-auto">
					<div className="w-[726px] h-[64px] flex items-center justify-center text-[#193D34] text-[32px] font-semibold leading-[32px] text-center font-[Montserrat] exact-1024:w-full exact-1024:max-w-[90%] exact-1024:h-auto exact-1024:text-[24px] exact-1024:leading-[30px]">
						Powerful Features <br /> For Unmatched Dropshipping Success
					</div>
					<div className="w-[692px] h-[56px] flex items-center justify-center text-[#47645D] text-[18px] font-medium leading-[28px] text-center font-[Montserrat] exact-1024:w-full exact-1024:max-w-[90%] exact-1024:h-auto exact-1024:text-[16px] exact-1024:leading-[24px]">
						Maximise your profits and source winning Dropshipping products
						without the hassle of time-consuming manual research.
					</div>
				</div>

				{/* Features Container */}
				<div className="flex flex-col gap-16 exact-1024:gap-8">
					{/* First Row */}
					<div className="flex flex-row  flex-wrap gap-16 items-center justify-center exact-1024:hidden-wrap exact-1024:gap-8">
						{featureCardsRow1.map((content, index) => (
							<Card key={index} variant="feature" content={content} />
						))}
					</div>
					{/* Second Row */}
					<div className="flex flex-row gap-16 items-center justify-center exact-1024:hidden-wrap exact-1024:gap-8">
						{featureCardsRow2.map((content, index) => (
							<Card key={index} variant="feature" content={content} />
						))}
					</div>
				</div>
			</div>

			{/***Section4 End */}

			{/***Section5 Start */}

			<div
				className="w-full h-[440px] exact-1024:h-[890px] absolute top-[3198.02px] exact-1024:top-[2998.02px]  flex items-center justify-center 
             hidden above-1024:flex exact-1024:flex overflow-hidden exact-1024:overflow-hidden"
			>
				{/* Left image */}
				<img
					loading="lazy"
					decoding="async"
					src="/assets/home/section5/xl_right_bag.svg"
					alt="Left Bag"
					className="absolute left-0 h-[760px] max-w-[400px] exact-1024:w-[180px] exact-1024:mt-[-207px]  object-contain"
				/>

				{/* Centered Text Container - Now Positioned Closer to Right Image */}
				<div className="w-full flex justify-end pr-[150px] ml-[-50px] ">
					<div className="w-[661px] h-[190px] flex flex-col gap-[32px] text-center">
						<div
							className="font-montserrat font-semibold text-[32px]  exact-1024:text-[24px] 
                        exact-1024:ml-[250px] exact-1024:mt-[30px] leading-[32px] text-[#0B1A16] hidden
                        above-1024:block exact-1024:flex"
						>
							Rbet Compare: Use AI-powered <br /> precision to compare the best
							deals
						</div>
						<div className="font-montserrat font-medium text-[18px] exact-1024:text-[12px] exact-1024:w-[390px] exact-1024:ml-[250px] exact-1024:mt-[20px] leading-[18px] text-[#47645D] text-left pl-4">
							Make your product sourcing effortless by comparing niche products
							across top suppliers like Amazon, eBay, AliExpress, Walmart, and
							many more. Evaluate the best prices, fastest shipping times, stock
							availability, and optimum quality to instantly identify the best
							deals, all with minimal effort!
						</div>
					</div>
				</div>

				{/* Right image */}
				<img
					loading="lazy"
					decoding="async"
					src="/assets/home/section5/xl_left_bag.svg"
					alt="Right Bag"
					className="absolute right-0 h-[760px] exact-1024:h-[660px] max-w-[400px] object-contain mt-[257px] exact-1024:mt-[10px] exact-1024:w-[180px]"
				/>
			</div>

			<div
				className="absolute w-[441px]   h-[56px] top-[3175.51px] exact-1024:top-[3005px] left-[400px] exact-1024:left-[400px]
                     p-[12px_16px] gap-[8px] rounded-[8px] bg-[#C5E190] shadow-md flex items-center 
                     hidden above-1024:flex exact-1024:flex"
			>
				{/* Icon */}
				<img
					loading="lazy"
					decoding="async"
					src="/assets/home/section5/shopping-bag-3-fill.svg"
					alt="Icon"
					className="w-[24px] h-[24px]"
				/>

				{/* Text: "Added to compare." */}
				<p className="font-montserrat font-normal text-[16px] leading-[32px] text-[#262A29]">
					Added to compare.
				</p>

				{/* Third Layout: "Check Rbet Compare." */}
				<div className="w-[178px] h-[32px] flex items-center justify-center gap-1 rounded">
					<span className="text-[#262A29]">Check</span>
					<a
						className="font-montserrat font-normal text-[16px] leading-[32px] text-[#262A29] underline flex items-center whitespace-nowrap"
						href="/"
					>
						Rbet Compare
						<span className="ml-3">
							<X size={16} />
						</span>
					</a>
				</div>
			</div>

			<button
				className="absolute top-[3235.51px] exact-1024:top-[3135.51px] left-[142px] w-[96px] h-[32px] p-[8px]  rounded-[24px] flex items-center 
            justify-center bg-transparent hover:bg-white/10 transition hidden above-1024:flex exact-1024:block"
			>
				<img
					loading="lazy"
					decoding="async"
					src="/assets/home/section5/sortButton.svg"
					alt="Sort By Icon"
					className="w-full h-full object-contain"
				/>
			</button>

			<button
				className="absolute top-[3282.51px] exact-1024:top-[3185.51px] left-[117px] w-[224px] h-[44px]
             px-[6px] py-[8px] bg-[#193D34] rounded-[24px] text-white text-center  flex items-center justify-center
              hidden above-1024:flex exact-1024:block"
			>
				Compare
			</button>

			{/* Card 1 */}
			<div className="hidden above-1024:block exact-1024:block absolute w-[171.385px]  h-[233.18px] top-[3417.51px] left-[72px] pt-[3.81px] pb-[3.81px] rounded-[3.81px] bg-[#F1F6E9]">
				{/* 1st Div */}
				<div className="w-[171.45px] h-[87px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section5/xl_card_1.svg"
						alt="Product"
						className="w-full h-full object-cover rounded-t"
					/>
				</div>

				{/* 2nd Div */}
				<div className="flex flex-col w-[156.15px] h-[32.37px] gap-[3.81px] p-[3.81px]">
					<div className="w-[148.53399658203125px] h-[24.755666732788086px] font-montserrat font-medium text-[7.62px] leading-[11.43px] tracking-[0%] text-[#262A29]">
						Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine
					</div>
				</div>
				<div className="w-[156.151px] h-[50.851px] pb-[1.9px] pl-[3.81px] gap-[1.9px] flex flex-col">
					<div className="w-[152.343px] h-[16px] font-montserrat font-semibold text-[15.23px] leading-[15.23px] tracking-[0%] align-middle text-[#193D34]">
						$9.199.999,99 US
					</div>
					<div className="w-[87px] h-[12px] font-montserrat font-semibold text-[6.9px] leading-[11.43px] tracking-[0%] align-middle text-[#464646]">
						Free Shipping Today!
					</div>
					<div className="w-[152px] h-[17px] flex flex-col items-end">
						<div className="w-[38px] h-[5px] font-montserrat font-normal text-[5.71px] leading-[100%] tracking-[0%] align-middle text-[#17382F]">
							Available on
						</div>
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section5/xl_amazon.svg"
							alt="amazonLog"
						/>
					</div>

					<div className="w-[171.39px] h-[47.61px] pt-[3.81px] pr-[7.62px] pb-[9.52px] pl-[7.62px] gap-[3.81px] flex flex-col">
						<button className="w-[156.15px] h-[15.23px] pt-[3.81px] pr-[2.86px] pb-[3.81px] pl-[2.86px] gap-[4.76px] bg-[#193D34] rounded-[11.43px] flex justify-center items-center">
							<span className="w-[150.44px] h-[12px] font-montserrat font-medium text-[6.19px] leading-[11.43px] tracking-[0%] text-center text-[#F6F6F6]">
								Compare
							</span>
						</button>
						<button className="w-[156.15px] h-[15.23px] pt-[3.81px] pr-[2.86px] pb-[3.81px] pl-[2.86px] gap-[4.76px] bg-transparent border border-[#193D34] rounded-[11.43px] flex justify-center items-center">
							<span className="w-[150.44px] h-[12px] font-montserrat font-medium text-[6.19px] leading-[11.43px] tracking-[0%] text-center text-[#193D34]">
								View Details
							</span>
						</button>
					</div>
				</div>
			</div>

			{/* Card 2 */}
			<div className="hidden above-1024:block exact-1024:block  absolute w-[142.82px] h-[201.85px] top-[3354.51px] exact-1024:top-[3244.51px] left-[210px] z-10 bg-[#F1F6E9] shadow flex flex-col gap-[2.01px] pt-[2.01px] rounded-[2.01px] w-[75.37] ">
				{/* 1st Div – Image Container */}
				<div className="w-[143px] h-[113px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section5/xl_card_2.svg"
						alt="Product"
						className="w-full h-full object-cover"
					/>
				</div>

				{/* 2nd Div – Price & Label Container */}
				<div className="w-[142px] h-[35px] pt-[1.01px] pr-[4.02px] pb-[1.01px] pl-[4.02px]">
					{/* 1st Subdiv – Price */}
					<div className="w-[128px] h-[18px] font-montserrat font-semibold text-[15.23px] leading-[15.23px] tracking-[0%] text-center align-middle">
						$1234567.67 US
					</div>
					{/* 2nd Subdiv – Lowest Price Label */}
					<div className="w-[128px] h-[11px] font-montserrat font-semibold text-[6.19px] leading-[11.43.px] tracking-[0%] text-center text-[#17382F]">
						Lowest Price on Amazon !
					</div>
				</div>

				{/* 3rd Div – Buttons Container */}
				<div className="w-[142px] h-[41px] pr-[7.62px] pb-[7.62px] pl-[7.62px] gap-[3.81px] flex flex-col">
					{/* 1st Button – Add to Shopify */}
					<button className="w-[128px] h-[15px] pt-[2.01px] pr-[1.51px] pb-[2.01px] pl-[1.51px] gap-[2.51px] rounded-[6.03px] bg-[#193D34] font-montserrat font-medium text-[6.19px] leading-[11.43px] tracking-[0%] text-center align-middle text-[#F6F6F6]">
						Add to Shopify
					</button>
					{/* 2nd Button – Go to Amazon */}
					<button className="w-[128px] h-[15px] pt-[2.01px] pr-[1.51px] pb-[2.01px] pl-[1.51px] gap-[2.51px] rounded-[6.03px] border-[0.25px] border-[#193D34] font-montserrat font-medium text-[6.19px] leading-[100%] tracking-[0%] text-center align-middle text-[#193D34]">
						Go to Amazon
					</button>
				</div>
			</div>

			{/* Card 3 */}

			<div className="hidden above-1024:block exact-1024:block absolute w-[190px]  h-[259.67px] top-[3249.51px] exact-1024:top-[3099.51px] left-[356px] z-10 bg-[#DEEEBF] shadow flex flex-col gap-[2.01px] pt-[2.01px] rounded-[2.01px] w-[75.37] ">
				{/* 1st Div – Image Container */}
				<div className="w-[180px] h-[151px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section5/xl_card_3.svg"
						alt="Product"
						className="w-full h-full object-cover"
					/>
				</div>

				{/* 2nd Div – Price & Label Container */}
				<div className="w-[180px] h-[39px] pt-[1.01px] pr-[4.02px] pb-[1.01px] pl-[4.02px]">
					{/* 1st Subdiv – Price */}
					<div className="w-[160px] h-[21px] font-montserrat font-semibold text-[20px] leading-[20px] tracking-[0%] text-center align-middle">
						$1234567.67 US
					</div>
					{/* 2nd Subdiv – Lowest Price Label */}
					<div className="w-[160px] h-[15px] font-montserrat font-semibold text-[8.23px] leading-[11.43.px] tracking-[0%] text-center text-[#17382F]">
						Lowest Price on Amazon !
					</div>
				</div>

				{/* 3rd Div – Buttons Container */}
				<div className="w-[180px] h-[56px] pr-[7.62px] pb-[7.62px] pl-[7.62px] gap-[3.81px] flex flex-col">
					{/* 1st Button – Add to Shopify */}
					<button className="w-[159.6px] h-[20.27px] px-[3.8px] py-[5.07px] gap-[6.33px] rounded-[15.2px] bg-[#193D34] font-montserrat font-medium text-[8.23px] leading-[15.2px] tracking-[0%] text-center text-[#F6F6F6] flex items-center justify-center">
						Add to Shopify
					</button>

					{/* 2nd Button – Go to Amazon */}
					<button className="w-[159.6px] h-[20.27px] pt-[5.07px] pr-[3.8px] pb-[5.07px] pl-[3.8px] gap-[6.33px] rounded-[15.2px] border-[0.63px] border-[#193D34] font-montserrat font-medium text-[8.23px] leading-[100%] tracking-[0%] text-center align-middle text-[#193D34]">
						Go to Amazon
					</button>
				</div>
			</div>

			{/* Card 4 */}

			<div className="hidden above-1024:block exact-1024:block absolute w-[171.39px]  h-[233.19px] top-[3415.51px] left-[263px]  pt-[3.81px] pb-[3.81px] rounded-[3.81px] bg-[#F1F6E9]">
				{/* 1st Div */}
				<div className="w-[171.45px] h-[87px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section5/xl_card_1.svg"
						alt="Product"
						className="w-full h-full object-cover rounded-t"
					/>
				</div>

				{/* 2nd Div */}
				<div className="flex flex-col w-[156.15113830566406px] h-[32.37279510498047px] gap-[3.81px] p-[3.81px]">
					<div className="w-[148.53399658203125px] h-[24.755666732788086px] font-montserrat font-medium text-[7.62px] leading-[11.43px] tracking-[0%] text-[#262A29]">
						Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine
					</div>
				</div>
				<div className="w-[156.151px] h-[50.851px] pb-[1.9px] pl-[3.81px] gap-[1.9px] flex flex-col">
					<div className="w-[152.343px] h-[16px] font-montserrat font-semibold text-[15.23px] leading-[15.23px] tracking-[0%] align-middle text-[#193D34]">
						$9.199.999,99 US
					</div>
					<div className="w-[87px] h-[12px] font-montserrat font-semibold text-[6.9px] leading-[11.43px] tracking-[0%] align-middle text-[#464646]">
						Free Shipping Today!
					</div>
					<div className="w-[152px] h-[17px] flex flex-col items-end">
						<div className="w-[38px] h-[5px] font-montserrat font-normal text-[5.71px] leading-[100%] tracking-[0%] align-middle text-[#17382F]">
							Available on
						</div>
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section5/xl_amazon.svg"
							alt="amazonLog"
						/>
					</div>

					<div className="w-[171.39px] h-[47.61px] pt-[3.81px] pr-[7.62px] pb-[9.52px] pl-[7.62px] gap-[3.81px] flex flex-col">
						<button className="w-[156.15px] h-[15.23px] pt-[3.81px] pr-[2.86px] pb-[3.81px] pl-[2.86px] gap-[4.76px] bg-[#193D34] rounded-[11.43px] flex justify-center items-center">
							<span className="w-[150.44px] h-[12px] font-montserrat font-medium text-[6.19px] leading-[11.43px] tracking-[0%] text-center text-[#F6F6F6]">
								Compare
							</span>
						</button>
						<button className="w-[156.15px] h-[15.23px] pt-[3.81px] pr-[2.86px] pb-[3.81px] pl-[2.86px] gap-[4.76px] bg-transparent border border-[#193D34] rounded-[11.43px] flex justify-center items-center">
							<span className="w-[150.44px] h-[12px] font-montserrat font-medium text-[6.19px] leading-[11.43px] tracking-[0%] text-center text-[#193D34]">
								View Details
							</span>
						</button>
					</div>
				</div>
			</div>

			{/***Section5 End */}

			{/***Section6 Start */}

			<div className="hidden above-1024:flex exact-1024:block w-full  flex flex-col items-center h-[890px] justify-center absolute top-[3900.51px] overflow-hidden">
				{/* Background Image */}
				<div className="absolute right-0  z-[-1] w-full sm:w-auto ">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section6/bgImg.svg"
						alt="BannerSection6"
						className="w-full sm:w-auto h-auto object-cover"
					/>
				</div>
				{/* Wrapper for Title and Grid Swipers */}
				<div className="w-[1256px] exact-1024:w-full flex flex-col items-center gap-16 hidden above-1024:flex exact-1024:block">
					{/* Title */}
					<div className="w-full h-[64px] text-[#193D34] text-[28px] font-semibold leading-[32px] font-[Montserrat]">
						Recommended categories
					</div>

					{/* First Row */}

					<div
						className="relative w-full flex justify-center overflow-visible
                            exact-1024:px-16 exact-1024:mb-[45px]"
					>
						{/* Navigation Buttons for 1st Row */}
						<button
							className="custom-prev-row1 absolute left-[-50px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 above-1024:ml-[-40px] 
                                    swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed  exact-1024:left-[0px]  "
						>
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button
							className="custom-next-row1 absolute right-[-50px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 
                                    swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed exact-1024:right-[-5px] "
						>
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper for 1st Row */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={4}
							spaceBetween={10}
							navigation={{
								nextEl: ".custom-next-row1",
								prevEl: ".custom-prev-row1",
							}}
							centeredSlides={false}
							breakpoints={{
								1024: { slidesPerView: 3, spaceBetween: 10 },
								1440: { slidesPerView: 4, spaceBetween: 10 },
								1920: { slidesPerView: 4, spaceBetween: 10 },
							}}
							slidesOffsetBefore={30}
							slidesOffsetAfter={20}
							className="w-full"
						>
							{categoriesCardRow1.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="categories" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>

					{/* Second Row */}
					<div
						className="relative w-full flex justify-center overflow-visible
                            exact-1024:px-16"
					>
						{/* Navigation Buttons for 2nd Row */}
						<button
							className="custom-prev-row2 absolute left-[-50px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 above-1024:ml-[-40px] 
                                    swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed  exact-1024:left-[-5px]  "
						>
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button
							className="custom-next-row2 absolute right-[-50px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 
                                    swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed exact-1024:right-[-3px] "
						>
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper for 2nd Row */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={4}
							spaceBetween={10}
							navigation={{
								nextEl: ".custom-next-row2",
								prevEl: ".custom-prev-row2",
							}}
							centeredSlides={false}
							breakpoints={{
								1024: { slidesPerView: 3, spaceBetween: 10 },
								1440: { slidesPerView: 4, spaceBetween: 10 },
								1920: { slidesPerView: 4, spaceBetween: 10 },
							}}
							slidesOffsetBefore={30}
							slidesOffsetAfter={20}
							className="w-full"
						>
							{categoriesCardRow2.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="categories" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>

			{/***Section6 End */}

			{/***Section7 Start */}

			<div className="w-full  flex flex-col items-center  justify-center absolute  h-[740px] top-[4803.51px] overflow-hidden hidden above-1024:flex exact-1024:block">
				{/* Wrapper for Title and Grid Swipers */}
				<div className="w-[1256px] flex flex-col items-center gap-16">
					{/* Title */}
					<div className="w-full h-[64px] text-[#193D34] text-[28px] font-semibold leading-[32px] font-[Montserrat] flex flex-row items-center">
						About Our Successful Customers...
						{/* Button with Space */}
						<button
							className="ml-4 flex items-center justify-center gap-[2px] w-[104px] h-[32px] rounded-[24px] border border-btnBorderColor p-[8px]"
							style={{
								fontFamily: "Montserrat, sans-serif",
								fontWeight: 500,
								fontSize: "13px",
								lineHeight: "24px",
								letterSpacing: "0%",
								color: "#193D34",
							}}
						>
							{/* Text Div */}
							<div className="w-[70px] h-[16px] flex items-center justify-center text-center">
								See More
							</div>

							{/* Arrow Icon */}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="14"
								height="14"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								className="lucide lucide-chevron-right"
							>
								<path d="m9 18 6-6-6-6" />
							</svg>
						</button>
					</div>

					{/*  Row */}
					<div className="relative w-full flex justify-center px-[20px]">
						{/* Navigation Buttons */}
						<button className="custom-prev-row1 absolute left-[-80px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#CFE6A2] flex items-center justify-center z-10">
							<ChevronLeft size={24} className="text-white" />
						</button>
						<button className="custom-next-row1 absolute right-[-80px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#CFE6A2] flex items-center justify-center z-10">
							<ChevronRight size={24} className="text-white" />
						</button>
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={10}
							centeredSlides={false}
							navigation={{
								nextEl: ".custom-next-row1",
								prevEl: ".custom-prev-row1",
							}}
							className="w-full"
						>
							{homeSection7Cards.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="homeSection7" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>

			{/***Section7 End */}

			{/***Section8 Start */}

			<div
				className="hidden above-1024:flex exact-1024:block absolute w-full h-[1200px] top-[5663.51px] bg-[#DEEEBF]
             p-[40px_72px] gap-[24px] flex flex-col items-center exact-1024:overflow-hidden"
			>
				{/* 1st Div */}
				<div className="exact-1024:w-full w-[1256px] h-[32px] px-[80px]  flex  items-center exact-1024:mb-[24px]">
					<div className="w-[67px] h-[32px] text-[#193D34] text-[28px] font-semibold leading-[32px] text-center font-[Montserrat]">
						Blog
					</div>
				</div>

				{/* 2nd Div */}
				<div className="exact-1024:w-full w-[1080px] h-[32px]  text-[20px] font-semibold leading-[32px] font-[Montserrat] exact-1024:mb-[24px]">
					Find the best advice and actionable insights on dropshipping in our
					blog section
				</div>

				{/* 3rd Div */}
				<div className="exact-1024:w-full w-[1080px] h-[30px]  flex gap-[20px] overflow:hidden exact-1024:mb-[24px]">
					{/* 1st Button */}
					<div className="w-[41px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#47645D] flex items-center justify-center">
						<button className="text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							All
						</button>
					</div>

					{/* 2nd Button */}
					<div className="w-[113px] h-[30px] gap-[10px] rounded-[20px] border border-[#95A6A2] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className=" text-[#E8ECEB] font-montserrat font-medium text-[13px] leading-none text-center">
							Sports Goods
						</button>
					</div>

					{/* 3rd Button */}
					<div className="w-[107px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className=" text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Pet Supplies
						</button>
					</div>

					{/* 4th Button */}
					<div className="w-[108px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className=" text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Electro Tools
						</button>
					</div>

					{/* 5th Button */}
					<div className="w-[55px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className=" text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Gifts
						</button>
					</div>

					{/* 6th Button */}
					<div className="w-[89px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className="text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Hardware
						</button>
					</div>

					{/* 7th Button */}
					<div className="w-[130px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className="text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Home & Garden
						</button>
					</div>

					{/* 8th Button */}
					<div className="w-[123px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className=" text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Office Supplies
						</button>
					</div>

					{/* 9th Button */}
					<div className="w-[154px] h-[30px] gap-[10px] rounded-[20px] border border-[#A7C56A] pt-[8px] pr-[12px] pb-[8px] pl-[12px] bg-[#657D77] flex items-center justify-center">
						<button className="text-bgSecondary font-montserrat font-medium text-[13px] leading-none text-center">
							Industrial Machines
						</button>
					</div>
				</div>

				{/* 4th Div */}
				<div className="exact-1024:w-full w-[1120px] h-[400px] bg-[#F1F6E9] rounded-[8px] p-[16px_20px] flex gap-[32px] exact-1024:mb-[24px]">
					{/* Left Side Div */}
					<div className="w-[524px] h-[320px]">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section8/picture.svg"
							alt="Description"
							className="w-full h-full object-cover rounded-[8px]"
						/>
					</div>

					{/* Right Side Div */}
					<div className="w-[524px] h-[368px] p-[8px] flex flex-col gap-[16px]">
						{/* 1st Sub Div */}
						<div className="w-[508px] h-[56px]">
							<p className="font-montserrat font-semibold text-[20px] leading-[28px] text-[#193D34]">
								Transforming Dreams into Reality with Retail Arbitrage
								Dropshipping.
							</p>
						</div>

						{/* 2nd Sub Div */}
						<div className="w-[508px] h-[232px] flex flex-col gap-[8px]">
							<div className="w-[508px] h-[200px]">
								<p className="font-montserrat font-normal text-[16px] leading-[28px] text-[#17382F]">
									In the competitive world of e-commerce, success stories often
									begin with a combination of passion, perseverance, and the
									right tools. Meet Alex Bennett, an aspiring entrepreneur whose
									journey into online retailing took a significant leap forward
									with Retail Arbitrage (RA) Dropshipping software.
								</p>
							</div>
						</div>

						{/* 3rd Sub Div */}
						<div className="w-[337px] h-[24px] flex items-center gap-[8px] pb-[8px]">
							<img
								loading="lazy"
								decoding="async"
								src="/assets/home/section8/middleDivClock.svg"
								alt="Icon"
								className="w-[16px] h-[16px]"
							/>
							<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#64748B]">
								4 min read time
							</span>
						</div>

						{/* 4th Sub Div */}
						<div className="w-[167px] h-[32px] p-[8px] flex items-center justify-center gap-[2px] rounded-[24px] bg-[#B7D974] ">
							<button className="font-montserrat font-medium text-[13px] leading-[24px] text-center text-[#193D34]">
								Read More
							</button>
						</div>
					</div>
				</div>
				{/* 5th Div - Additional Content */}
				<div className="exact-1024:w-full flex justify-between w-[1120px] h-[500px]  rounded-[8px] exact-1024:mb-[24px] exact-1024:overflow-hidden">
					{homeSection8MobileCards.map((card, index) => (
						<Card variant="homeSection8Desktop" key={index} content={card} />
					))}

					{/* Centered Button at the Bottom */}
					<button className="absolute bottom-[2%] exact-1024:bottom-[1.5%] left-1/2 transform -translate-x-1/2 w-[167px] h-[44px] rounded-[24px] font-montserrat font-medium text-[13px] leading-[24px] text-center text-[#193D34] flex items-center justify-center gap-[2px] bg-[#B7D974]">
						Read More
					</button>
				</div>
			</div>

			{/***Section8 End */}

			{/***Section9 Start */}

			<div className="hidden above-1024:flex exact-1024:block relative flex flex-col items-center w-full px-4 py-16 top-[6193.51px]">
				{/* Heading */}
				<h2 className="text-[#0B1A16] font-montserrat font-semibold text-[32px] leading-[32px] text-center mb-8">
					Get started with these easy steps:
				</h2>

				{/* Steps Container */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6 exact-1024:w-full max-w-[1200px] justify-center">
					{homeSection9Arr.map((step, index) => (
						<div
							key={index}
							className="flex gap-4 w-[376px] exact-1024:w-full items-center exact-1024:items-start"
						>
							{/* Step Number */}
							<div className="w-[48px] h-[54px] bg-[#B7D974] rounded-[4px] flex items-center justify-center">
								<div className="text-[#47645D] font-montserrat font-medium text-[32px] leading-[32px] text-center">
									{step.number}
								</div>
							</div>
							{/* Step Description */}
							<div className="exact-1024:w-full w-[304px] text-[#47645D] font-montserrat font-medium text-[16px] leading-[24px] p-2">
								{step.text}
							</div>
						</div>
					))}
				</div>
			</div>

			{/***Section9 End */}

			{/***Section10 Start */}

			<div className="hidden above-1024:flex exact-1024:flex absolute w-full h-[520px] top-[7768px] bg-[#CFE6A2] flex justify-center items-center gap-[56px] px-[72px] pt-[40px] pb-[40px]">
				{/***First Div*/}
				<div className="w-[539px] h-[200px]  flex justify-center items-center p-6">
					<p className="font-montserrat font-semibold text-[32px] leading-[40px] text-[#47645D]">
						Gain the Rbetraj advantage! Eliminate time-consuming tasks, reduce
						unwanted errors and stay ahead of the competition.
					</p>
				</div>

				{/***Second Div*/}
				<div
					className="w-[440px] h-[440px] bg-[#47645D] rounded-full flex justify-center items-center 
                overflow-hidden z-10 relative"
				>
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section10/circleImgSection10.svg"
						alt="section10Picture"
						className="w-full h-full object-cover"
					/>
				</div>
			</div>
			{/***Third Div*/}
			<div className="hidden above-1024:flex exact-1024:block absolute w-full max-w-[425px] h-auto left-[80%] translate-x-[-50%] top-[7510px] responsive-top">
				<img
					loading="lazy"
					decoding="async"
					src="/assets/home/section10/bag2.svg"
					className="w-full h-auto"
					alt="Bag 1"
				/>
			</div>
			<div className="hidden above-1024:flex exact-1024:block absolute w-full max-w-[425px] h-auto left-[70%] translate-x-[-50%] top-[7612px] responsive-top bg-transparent">
				<img
					loading="lazy"
					decoding="async"
					src="/assets/home/section10/bag1.svg"
					className="w-full h-auto"
					alt="Bag 2"
				/>
			</div>
			{/***Third End*/}

			{/***Section10 End */}

			{/***Section11 Start */}

			<div className="hidden lg:flex absolute w-full h-[615px] top-[8430px] gap-[32px] pt-[8px] pr-[72px] pb-[8px] pl-[72px] flex flex-col items-center">
				{/* First Div */}
				<div className="w-[540px] h-[78px] text-center">
					<p className="font-montserrat font-semibold text-[32px] leading-none text-[#193D34]">
						Get started with Rbetraj! Dropship Your Way to Success!
					</p>
				</div>

				{/* Second Div */}
				<div className="w-[540px] h-[60px] text-center">
					<p className="font-montserrat font-medium text-[16px] leading-none text-[#47645D]">
						Sign up for our Dropshipping Automation Software today, simplify the
						process of finding top products and scale your online store with
						ease. Become an experienced seller!
					</p>
				</div>

				{/* Button */}
				<Link to="/login">
					<button className="w-[224px] h-[44px] rounded-[24px] p-[8px_6px] font-montserrat font-medium text-[13px] leading-[24px] bg-[#193D34] text-white">
						Create Account
					</button>
				</Link>
			</div>

			{/***Section11 End */}

			{/***Section12 Start */}

			<div
				className="hidden above-1024:flex exact-1024:flex absolute w-full h-[615px] exact-1024:h-auto
            top-[8870px] gap-[32px] pt-[8px] pr-[72px] pb-[8px] pl-[72px] flex flex-col items-center exact-1024:overflow-hidden"
			>
				{/* First Div */}
				<div className="w-[1110px] h-[68px] flex flex-col items-center gap-[8px]">
					<div className="w-[1110px] h-[32px] text-[#17382F] text-[28px] font-semibold leading-[32px] text-center font-[Montserrat]">
						FAQ
					</div>
					<div className="w-[888px] h-[28px] text-[#193D34] text-[16px] font-normal leading-[28px] text-center font-[Montserrat]">
						Have questions? Find quick, helpful answers to help you get started
						with Rbetraj.
					</div>
				</div>

				{/* Second Div */}
				<div className="w-full max-w-[1256px] flex flex-wrap gap-6 justify-center">
					<div className="w-full flex flex-wrap justify-center gap-6">
						{faqCardsRow1.map((card, index) => (
							<Card
								key={index}
								variant="faq"
								content={card}
								className="w-[240px] h-[225px] rounded-[8px] flex items-center justify-center exact-1024:w-[31%]"
							/>
						))}
					</div>
					<div className="w-full flex flex-wrap justify-center gap-6">
						{faqCardsRow2.map((card, index) => (
							<Card
								key={index}
								variant="faq"
								content={card}
								className="w-[240px] h-[225px] rounded-[8px] flex items-center justify-center exact-1024:w-[31%]"
							/>
						))}
					</div>
				</div>

				{/* Third Div - Read More Button */}
				<div className="w-[167px] h-[44px] flex items-center justify-center gap-[2px] rounded-[24px] p-[8px] bg-[#B7D974] mt-8 text-center">
					<Link to="/faq">
						<button className="text-[#193D34] font-[Montserrat] font-medium text-[13px] leading-[24px] ">
							Read More
						</button>
					</Link>
				</div>
			</div>

			{/***Section12 End*/}

			{/* Section13 Start */}

			{/**Not In Mobile Design */}
			<div className="hidden lg:flex absolute w-full h-[521px] exact-1024:h-[800px] top-[9890px]  flex items-center p-0 m-0">
				{/* Left-side Icon */}
				<div className="w-[451px] h-[480px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/left_bag.png"
						alt="Left Icon"
						className="object-contain exact-1024:w-[30%] exact-1024:h-full"
					/>
				</div>

				{/* Right-side Icon (Push to the Right) */}
				<div className="w-[451px] h-[520px] ml-auto flex justify-end">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/right_bag.png"
						alt="Right Icon"
						className="object-contain exact-1024:w-[30%] exact-1024:h-full"
					/>
				</div>
			</div>
			<div className="hidden lg:block absolute w-[142.82px] h-[195.19px] top-[9816px] left-[396px] exact-1024:left-[296px] rounded-[3.81px] shadow-[rgba(0,0,0,0.32)_-25.21px_16.8px_42.01px_0px] bg-[#DEEEBF]">
				{/* Icon Image Container */}
				<div className="absolute w-[135.2px] h-[113.3px] top-[3.81px] left-[3.81px] rounded-[3.81px] bg-gray-200 flex items-center justify-center">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/card1.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-[3.81px]"
					/>
				</div>

				{/* Price and Description Container */}
				<div className="absolute w-[135.2px] h-[29.33px] top-[120.92px] left-[3.81px] px-[7.62px] pt-[1.9px] pb-[1.9px]">
					<div className="w-[119.97px] h-[16px] text-[#17382F] font-montserrat font-semibold text-[15.23px] leading-[15.23px] text-center">
						$123,123.111 US
					</div>
					<div className="w-[119.97px] h-[11.43px] text-[#17382F] font-montserrat font-semibold text-[6.19px] leading-[11.43px] text-center">
						Lowest Price on Amazon !
					</div>
				</div>

				{/* Button Container */}
				<div className="absolute w-[135.2px] h-[41.89px] top-[153.29px] left-[3.81px] px-[7.62px] pb-[7.62px] flex flex-col items-center gap-[3.81px]">
					{/* Add to Shopify Button */}
					<div className="w-[119.97px] h-[15.23px] rounded-[11.43px] px-[2.86px] pt-[3.81px] pb-[3.81px] bg-[#193D34] flex items-center justify-center">
						<button className="w-[114.26px] h-[12px] text-[6.19px] font-montserrat font-medium text-[#F6F6F6] leading-[11.43px] text-center">
							Add to Shopify
						</button>
					</div>

					{/* Go to Amazon Button */}
					<div className="w-[119.97px] h-[15.23px] rounded-[11.43px] px-[2.86px] pt-[3.81px] pb-[3.81px] bg-[#DEEEBF] flex items-center justify-center border border-[#193D34]">
						<button className="w-[114.26px] h-[12px] text-[6.19px] font-montserrat font-medium text-[#193D34] leading-[11.43px] text-center">
							Go to Amazon
						</button>
					</div>
				</div>
			</div>
			{/**Card With 2nd Star */}
			<div className="hidden lg:block absolute w-[142.82px] h-[195.19px] top-[10022px] left-[468px] exact-1024:left-[358px] rounded-[3.81px] shadow-[rgba(0,0,0,0.32)_-25.21px_16.8px_42.01px_0px] bg-[#FFFF]">
				{/* Icon Image Container */}
				<div className="absolute w-[135.2px] h-[113.3px] top-[3.81px] left-[3.81px] rounded-[3.81px] bg-gray-200 flex items-center justify-center">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/card2.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-[3.81px]"
					/>
				</div>

				{/* Price and Description Container */}
				<div className="absolute w-[135.2px] h-[29.33px] top-[120.92px] left-[3.81px] px-[7.62px] pt-[1.9px] pb-[1.9px]">
					<div className="w-[119.97px] h-[16px] text-[#17382F] font-montserrat font-semibold text-[15.23px] leading-[15.23px] text-center">
						$123,123.111 US
					</div>
					<div className="w-[119.97px] h-[11.43px] text-[#17382F] font-montserrat font-semibold text-[6.19px] leading-[11.43px] text-center">
						Lowest Price on Amazon !
					</div>
				</div>

				{/* Button Container */}
				<div className="absolute w-[135.2px] h-[41.89px] top-[153.29px] left-[3.81px] px-[7.62px] pb-[7.62px] flex flex-col items-center gap-[3.81px]">
					{/* Add to Shopify Button */}
					<div className="w-[119.97px] h-[15.23px] rounded-[11.43px] px-[2.86px] pt-[3.81px] pb-[3.81px] bg-[#193D34] flex items-center justify-center">
						<button className="w-[114.26px] h-[12px] text-[6.19px] font-montserrat font-medium text-[#F6F6F6] leading-[11.43px] text-center">
							Add to Shopify
						</button>
					</div>

					{/* Go to Amazon Button */}
					<div className="w-[119.97px] h-[15.23px] rounded-[11.43px] px-[2.86px] pt-[3.81px] pb-[3.81px]  flex items-center justify-center border border-[#193D34]">
						<button className="w-[114.26px] h-[12px] text-[6.19px] font-montserrat font-medium text-[#193D34] leading-[11.43px] text-center">
							Go to Amazon
						</button>
					</div>
				</div>
			</div>
			{/**Card Below 1st Star */}
			<div className="hidden lg:block absolute w-[152.82px] h-[211.53px] top-[10059px] left-[303px]  exact-1024:left-[193px] rounded-[5.07px] shadow-[rgba(0,0,0,0.32)_-25.21px_16.8px_42.01px_0px] bg-[#FFFF]">
				{/* Icon Image Container */}
				<div className="absolute w-[152px] h-[145.67px] top-[3.81px] left-[3.81px] rounded-[3.81px] bg-gray-200 flex items-center justify-center">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/card3.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-[3.81px]"
					/>
				</div>

				{/* Electronic Devices Title */}
				<div className="absolute w-[152px] h-[55.73px] top-[153.29px] gap-[2.53px] pr-[10.13px] pb-[10.13px] pl-[10.13px] flex flex-col items-center">
					<div className="w-[132.37px] h-[15.2px] text-[12.67px] font-montserrat font-bold leading-[20.27px] text-[#193D34] text-center">
						Electronic Devices
					</div>

					{/* Smart Watches */}
					<div className="w-[132.37px] h-[7.6px] text-[7.6px] font-montserrat font-normal leading-[100%] text-[#7A7A7A] text-center">
						Smart Watches
					</div>

					{/* Price Range */}
					<div className="w-[132.37px] h-[7.6px] text-[7.6px] font-montserrat font-semibold leading-[100%] text-[#7A7A7A] text-center">
						From 29 to 49 USD
					</div>

					{/* Laptops & PC */}
					<div className="w-[132.37px] h-[7.6px] text-[7.6px] font-montserrat font-normal leading-[100%] text-[#7A7A7A] text-center">
						Laptops & PC
					</div>
				</div>
			</div>
			{/**Card at Bottom  */}
			<div className="hidden lg:block absolute w-[90.45px] h-[151.25px] top-[10216px] left-[410px] exact-1024:left-[310px] rounded-[3.81px] p-[3.81px] bg-[#F1F6E9] shadow-[rgba(0,0,0,0.32)_-25.21px_16.8px_42.01px_0px]">
				{/* Icon Container */}
				<div className="w-[82.84px] h-[83.31px] rounded-[3.81px] bg-gray-200 flex items-center justify-center">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/card4.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-[3.81px]"
					/>
				</div>

				{/* Price & Order Info Container */}
				<div className="w-[82.84px] h-[37.47px] gap-[1.9px] pr-[7.62px] pl-[7.62px] flex flex-col items-center mt-[3.81px]">
					{/* Price */}
					<div className="w-[67.60px] h-[11.43px] text-[9.52px] font-montserrat font-semibold leading-[15.23px] text-[#262A29] text-center">
						$229 - 239
					</div>

					{/* Minimum Order */}
					<div className="w-[67.60px] h-[5.71px] text-[5.71px] font-montserrat font-normal leading-[100%] text-[#7A7A7A] text-center">
						Min. Order: 10 pieces
					</div>

					{/* Price Range */}
					<div className="w-[56px] h-[7px] text-[5.71px] font-montserrat font-semibold leading-[100%] text-[#7A7A7A] text-center">
						From 29 to 49 USD
					</div>

					{/* Availability */}
					<div className="w-[67.60px] h-[7.62px] flex items-center justify-center mt-[3.81px]">
						<span className="w-[39.99px] h-[5.71px] text-[5.71px] font-montserrat font-normal leading-[100%] text-[#7A7A7A]">
							Available On
						</span>
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/footer/xl-footer-wallmart.svg"
							alt="Availability Icon"
							className="w-[7px] h-[7px] ml-1"
						/>
					</div>
				</div>

				{/* Button Section */}
				<div className="w-[82.84px] h-[15.23px] flex items-center justify-center mt-[3.81px]">
					<button className="bg-primary text-textColor text-[6.19px] font-montserrat font-medium leading-[11.43px] text-center rounded-[3.81px]">
						Compare
					</button>
				</div>
			</div>
			<div>
				{/* First Icon */}
				<div className="hidden lg:block absolute w-[80px] h-[80px] top-[9949px] left-[260px] exact-1024:left-[150px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/sparkling-fill-left.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-full"
					/>
				</div>

				{/* Second Icon */}
				<div className="hidden lg:block absolute w-[80px] h-[80px] top-[10019px] left-[602px] exact-1024:left-[520px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/sparkling-fill-center.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-full"
					/>
				</div>

				{/* Third Icon */}
				<div className="hidden lg:block absolute w-[80px] h-[80px] top-[9943px] left-[854px] ">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section13/sparkling-fill-right.png"
						alt="Icon"
						className="w-full h-full object-cover rounded-full"
					/>
				</div>
			</div>
			<div className="hidden lg:block absolute w-[406px] h-[178px] top-[10067px] exact-1024:top-[10160px] left-[670px]  exact-1024:left-[490px] flex items-center justify-center text-center text-[#193D34] font-montserrat font-semibold italic text-[32px] exact-1024:text-[30px] leading-[40px]">
				Start Dropshipping smarter, not harder, <br /> and let Rbetrage do the
				heavy lifting for you!
			</div>
			<button className="hidden lg:block absolute w-[224px] h-[44px] top-[10339px] left-[761px] exact-1024:left-[561px] rounded-[24px] px-[6px] py-[8px] gap-[10px] bg-[#193D34] text-white text-[13px] font-montserrat font-medium leading-[24px] text-center">
				Compare Now
			</button>
			<div
				className="absolute w-[80px] h-[80px] top-[10962px] left-0 bg-no-repeat bg-cover bg-center lg:hidden"
				style={{
					backgroundImage:
						"url('/assets/home/footer/mobile-left-sparkling-fill.svg')",
				}}
			></div>
			<div
				className="absolute w-[80px] h-[80px] top-[10862px] left-1/2 -translate-x-1/2 bg-no-repeat bg-cover bg-center lg:hidden"
				style={{
					backgroundImage:
						"url('/assets/home/footer/mobile-center-sparkling-fill.svg')",
				}}
			></div>
			<div
				className="absolute w-[80px] h-[80px] top-[10962px] right-0 bg-no-repeat bg-cover bg-center lg:hidden"
				style={{
					backgroundImage:
						"url('/assets/home/footer/mobile-right-sparkling-fill.svg')",
				}}
			></div>

			{/***Mobile Design */}
			<div
				className={`absolute w-full h-[575px]  lg:hidden  top-[11006px] flex items-center justify-center`}
				style={{
					backgroundImage: "url('/assets/home/footer/footerBag.svg')",
				}}
			>
				{/* Centered Inner Container */}
				<div className="w-[300px] h-[365.82px] flex flex-col items-center justify-between gap-[24px]">
					{/* First Inner Div (Text Content) */}
					<div className="w-[300px] h-[280px]  flex items-center justify-center text-center p-4">
						<p className="font-montserrat font-semibold italic text-[32px] leading-[40px] text-center text-[#E8ECEB]">
							Start Dropshipping smarter, not harder, and let Rbetraj do the
							heavy lifting for you!
						</p>
					</div>

					{/* Button */}
					<button className="w-[224px] h-[44.46px] bg-[#193D34] text-white font-montserrat font-medium text-[13px] leading-[24px] text-center rounded-[24px] px-[6px] py-[8px] hidden lg:block">
						Compare Now
					</button>
				</div>
			</div>

			{/***Mobile Design */}
			<div
				className={`absolute w-full h-[575px]  lg:hidden  top-[11006px] flex items-center justify-center`}
				style={{
					backgroundImage: "url('/assets/home/footer/footerBag.svg')",
				}}
			>
				{/* Centered Inner Container */}
				<div className="w-[300px] h-[365.82px] flex flex-col items-center justify-between gap-[24px]">
					{/* First Inner Div (Text Content) */}
					<div className="w-[300px] h-[280px]  flex items-center justify-center text-center p-4">
						<p className="font-montserrat font-semibold italic text-[32px] leading-[40px] text-center text-[#E8ECEB]">
							Start Dropshipping smarter, not harder, and let Rbetraj do the
							heavy lifting for you!
						</p>
					</div>

					{/* Button */}
					<button className="w-[224px] h-[44.46px] bg-[#193D34] text-white font-montserrat font-medium text-[13px] leading-[24px] text-center rounded-[24px] px-[6px] py-[8px] hidden lg:block">
						Compare Now
					</button>
				</div>
			</div>

			{/* Section13 End */}

			{/*Mobile + Tablet  Version */}

			{/*Section1*/}

			<div className="w-full lg:hidden">
				{/* Background Image */}
				<div className="absolute right-0 top-[-12px] z-[-1] w-full bg-[#fff] ">
					{/* Mobile Background Image */}
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section1/mobile/bannerBackground.svg"
						alt="Mobile Banner"
						className="object-cover absolute right-0 h-[560px] top-[40px]"
					/>
				</div>

				{/* Base Headline Section */}
				<div className="relative w-full min-h-[700px] flex flex-col justify-between items-center px-6 py-10 text-center">
					{/* Headline Section */}
					<h1 className="text-[32px] leading-[40px] font-semibold font-[Montserrat] text-[#17382F] text-left w-full">
						Maximize your <br /> Profits with <br />
						<span className="text-[#98B955]">
							Rbetraj’s Dropshipping Automation
						</span>
						<span className="text-[#17382F]">Software</span>
					</h1>

					{/* Image - Only visible on mobile */}
					<div className="w-full flex justify-center">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section1/mobile/banner.svg"
							alt="CircularMobile"
							className="w-[300px] h-[300px] rounded-full max-w-full"
						/>
					</div>

					{/* Description Section */}
					<p className="text-[16px] leading-[26px] font-medium font-[Montserrat] text-[#17382F]">
						Rbetraj’s AI-powered Dropshipping Automation Software is a powerful
						tool that quickly helps you find the most trending dropshipping
						products across major suppliers. Its intuitive and advanced
						filtering options ensure you grab the best deals and earn more
						profit.
					</p>

					{/* Button */}
					<Link to="/sign-up">
						<button className="w-[167px] h-[44px] rounded-[24px] bg-[#B7D974] text-[#193D34] font-[Montserrat] font-medium text-[13px] leading-[24px] tracking-[0%] text-center flex items-center justify-center mt-5">
							Start For Free
						</button>
					</Link>
				</div>
			</div>

			{/*Section1 End*/}

			{/*Section2 */}

			<div className="absolute w-full h-auto top-[956px] flex flex-col items-center gap-8 px-4 sm:px-6 md:px-8 flex lg:hidden">
				{/* Title & Description Container */}
				<div className="w-full max-w-[1110px] flex flex-col items-center gap-2 text-center">
					{/* Title Section */}
					<h2 className="text-[24px] sm:text-[28px] md:text-[32px] leading-tight font-semibold font-[Montserrat] text-[#47645D]">
						Our Marketplaces
					</h2>

					{/* Description Section */}
					<p className="text-[14px] sm:text-[16px] md:text-[18px] leading-[24px] md:leading-[28px] font-medium font-[Montserrat] text-[#193D34] max-w-[692px]">
						Discover Trending Dropshipping Products From Trustworthy Stores
						Across the Globe by Using the Best Dropshipping Product Research
						Software.
					</p>
				</div>

				{/* Swiper Container */}
				<div className="relative w-full max-w-[900px] h-auto flex items-center justify-center">
					{/* Custom Navigation Buttons */}
					<button className="swiper-button-prev custom-nav-button"></button>

					<Swiper
						modules={[Navigation]}
						slidesPerView={3}
						navigation={{
							prevEl: ".swiper-button-prev",
							nextEl: ".swiper-button-next",
						}}
						breakpoints={{
							480: { slidesPerView: 2.5, spaceBetween: 10 },
							768: { slidesPerView: 3.5, spaceBetween: 16 },
							1024: { slidesPerView: 5, spaceBetween: 24 },
						}}
						className="mySwiper w-full"
					>
						{marketplaceLogos.map((icon, index) => (
							<SwiperSlide
								key={index}
								className="flex justify-center items-center"
							>
								<img
									loading="lazy"
									decoding="async"
									src={`/assets/home/section2/slide/${icon}`}
									alt={icon.split(".")[0]}
									className="w-[80px] sm:w-[90px] md:w-[100px] h-[50px] sm:h-[55px] md:h-[57px] object-contain"
								/>
							</SwiperSlide>
						))}
					</Swiper>

					<button className="swiper-button-next custom-nav-button"></button>
				</div>
			</div>

			{/*Section2 End*/}

			{/*Section3 */}

			<div className="absolute w-full h-[722px] bg-[#CFE6A2] flex flex-col items-center top-[1420.2px] left-[1px] sm:flex lg:hidden">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						Most Loved Products This Month
					</div>

					{/* Swiper Container */}
					<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="section3navNone"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="section3navNone"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper Wrapper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={1.2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{productCards.map((card, index) => (
									<SwiperSlide>
										<Card variant="product_mobile" content={card} key={index} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination Below Swiper */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>

			{/*Section3 End*/}

			{/*Section4  */}

			<div className="absolute w-full overflow-x-hidden h-auto top-[2262.2px] pt-5 pb-5 flex flex-col items-center space-y-8 sm:flex lg:hidden">
				{/* Title Section */}
				<div className="w-full flex flex-col items-center gap-2 bg-white p-4 text-center">
					<div className="w-full max-w-[90%] text-[#193D34] text-[24px] font-semibold leading-[28px] font-[Montserrat]">
						Powerful Features <br /> For Unmatched Dropshipping Success
					</div>
					<div className="w-full max-w-[85%] text-[#47645D] text-[14px] font-medium leading-[22px] font-[Montserrat]">
						Maximise your profits and source winning Dropshipping products
						without the hassle of time-consuming manual research.
					</div>
				</div>

				{/* Features Container (Mobile Grid) */}
				<div className="grid grid-cols-1 gap-8  px-4">
					{featureCardsRow1.map((content, index) => (
						<Card key={index} variant="feature" content={content} />
					))}
					{featureCardsRow2.map((content, index) => (
						<Card key={index} variant="feature" content={content} />
					))}
				</div>
			</div>

			{/*Section4  End */}

			{/* Section5  */}

			<div className="lg:hidden mx-auto flex flex-col items-center justify-center gap-4 bg-white w-full  h-auto min-h-[776px]  top-[4786.2px] absolute top-0 left-1/2 -translate-x-1/2">
				<div className="absolute top-0 left-1/2 -translate-x-1/2 w-[339px] h-[170px] flex flex-col items-center justify-center text-center">
					<h1 className="font-montserrat font-semibold text-[32px] leading-[34px] tracking-[0%] text-[#0B1A16] text-center">
						Rbet Compare:
					</h1>
					<p className="font-montserrat text-[32px] font-semibold leading-[34px] tracking-[0%] text-[#0B1A16] text-center">
						Use AI-powered precision to compare the best deals
					</p>
				</div>
				{/* New Middle Div with specified dimensions */}
				<div className="w-[332.03px] h-[300.52px]">
					{/* Bag 1 */}
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section5/mobile_left_bag.svg"
						alt="Bag 1"
						className="absolute w-[168px] h-[181px] top-[281.8px] left-[28px] object-contain"
					/>
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/section5/mobile_right_bag.svg"
						alt="Bag 2"
						className="absolute w-[168.10630798339844px] h-[181.72755432128906px] top-[320.8px] left-[134px] object-contain"
					/>
					<button className="absolute w-[118.22px] h-[23.22px] top-[251.18px] left-[109.04px] pt-[4.22px] pr-[3.17px] pb-[4.22px] pl-[3.17px] gap-[5.28px] rounded-[12.67px] bg-[#193D34] text-white flex items-center justify-center">
						Compare
					</button>

					{/* Cards Container */}
					<div className="relative w-full h-[400px] mt-12">
						{/* Card 1 */}
						<div
							className="absolute bg-[#F1F6E9] shadow flex flex-col items-center w-[91px] top-[322.44px] left-[85.29px] pt-[2px] pb-[2px] rounded-[2px]
                                       md:w-[180px] md:top-[300px] md:left-[50px] md:pt-2 md:pb-2"
						>
							{/* Image */}
							<div className="w-[90px] h-[45px] overflow-hidden md:w-[130px] md:h-[70px]">
								<img
									loading="lazy"
									decoding="async"
									src="/assets/home/section5/mobile_card_1.svg"
									alt="Product"
									className="w-full h-full object-cover rounded-t"
								/>
							</div>

							{/* Content */}
							<div
								className="flex flex-col w-[90px] pt-[1px] pr-[4px] pl-[4px] gap-[3px]
                                            md:w-[130px] md:gap-2 md:pt-2 md:px-2"
							>
								{/* Title */}
								<div
									className="font-montserrat font-medium text-[4px] leading-[6px]
                                               md:text-[10px] md:leading-tight"
								>
									Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine
								</div>

								{/* Price & Shipping */}
								<div className="flex flex-col gap-[1px] md:gap-1">
									<div
										className="font-montserrat font-semibold text-[8px] leading-[8px]
                                                   md:text-[14px] md:leading-[14px]"
									>
										$9.199.999,99 US
									</div>
									<div
										className="font-montserrat font-semibold text-[3.2px] leading-[6px] text-gray-700
                                                   md:text-[8px] md:leading-[10px]"
									>
										Free Shipping Today!
									</div>
								</div>

								{/* Availability */}
								<div className="flex flex-col items-end text-gray-700 md:items-start">
									<p
										className="font-montserrat font-normal text-[3px] leading-[100%]
                                                   md:text-[7px] md:leading-[10px]"
									>
										Available On
									</p>
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/section5/mobile_amazon.svg"
										alt="amazonLog"
										className="w-[18px] h-[6px] md:w-[40px] md:h-[14px]"
									/>
								</div>

								{/* Buttons */}
								<div className="flex flex-col gap-1 mt-1 w-full">
									<button
										className="bg-[#193D34] text-white rounded-full font-montserrat font-medium
                                                   text-[3.2px] h-[8px] text-center md:text-[9px] md:h-[26px]"
									>
										Compare
									</button>
									<button
										className="border border-gray-300 rounded-full font-montserrat font-medium
                                                   text-[3.2px] h-[8px] text-center md:text-[9px] md:h-[26px]"
									>
										View Details
									</button>
								</div>
							</div>
						</div>
						{/* Card 2 */}
						<div
							className="absolute bg-[#F1F6E9] shadow flex flex-col items-center w-[91px] top-[289.18px] left-[158.12px] pt-[2px] pb-[2px] rounded-[2px]
                                       md:w-[180px] md:top-[250px] md:left-[180px] md:pt-2 md:pb-2"
						>
							{/* Image */}
							<div className="w-[90px] h-[45px] overflow-hidden md:w-[130px] md:h-[70px]">
								<img
									loading="lazy"
									decoding="async"
									src="/assets/home/section5/mobile_card_1.svg"
									alt="Product"
									className="w-full h-full object-cover rounded-t"
								/>
							</div>

							{/* Content */}
							<div className="flex flex-col w-[90px] pt-[1px] pr-[4px] pl-[4px] gap-[3px] md:w-[130px] md:gap-2 md:pt-2 md:px-2">
								<div className="font-montserrat font-medium text-[4px] leading-[6px] md:text-[10px] md:leading-tight text-center">
									Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine
								</div>

								<div className="font-montserrat font-semibold text-[8px] leading-[8px] md:text-[14px] md:leading-[14px] text-center">
									$1234567.67 US
								</div>

								<div className="font-montserrat font-semibold text-[3.2px] leading-[6px] text-[#17382F] md:text-[8px] md:leading-[10px] text-center">
									Lowest Price on Amazon!
								</div>

								<div className="flex flex-col gap-1 mt-1 w-full">
									<button className="bg-[#193D34] text-white rounded-full font-montserrat font-medium text-[3.2px] h-[8px] md:text-[9px] md:h-[26px]">
										Add to Shopify
									</button>
									<button className="border border-[#193D34] rounded-full font-montserrat font-medium text-[3.2px] h-[8px] text-[#193D34] md:text-[9px] md:h-[26px]">
										Go to Amazon
									</button>
								</div>
							</div>
						</div>

						{/* Card 3 */}
						<div
							className="absolute bg-[#F1F6E9] shadow flex flex-col items-center w-[91px] top-[233.18px] left-[235.18px] pt-[2px] pb-[2px] rounded-[2px]
                                       md:w-[180px] md:top-[200px] md:left-[330px] md:pt-2 md:pb-2"
						>
							<div className="w-[90px] h-[45px] overflow-hidden md:w-[130px] md:h-[70px]">
								<img
									loading="lazy"
									decoding="async"
									src="/assets/home/section5/mobile_card_3.svg"
									alt="Product"
									className="w-full h-full object-cover rounded-t"
								/>
							</div>

							<div className="flex flex-col w-[90px] pt-[1px] pr-[4px] pl-[4px] gap-[3px] md:w-[130px] md:gap-2 md:pt-2 md:px-2">
								<div className="font-montserrat font-medium text-[4px] leading-[6px] md:text-[10px] md:leading-tight text-center">
									Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine
								</div>

								<div className="font-montserrat font-semibold text-[8px] leading-[8px] md:text-[14px] md:leading-[14px] text-center">
									$1234567.67 US
								</div>

								<div className="font-montserrat font-semibold text-[3.2px] leading-[6px] text-[#17382F] md:text-[8px] md:leading-[10px] text-center">
									Lowest Price on Amazon!
								</div>

								<div className="flex flex-col gap-1 mt-1 w-full">
									<button className="bg-[#193D34] text-white rounded-full font-montserrat font-medium text-[3.2px] h-[8px] md:text-[9px] md:h-[26px]">
										Add to Shopify
									</button>
									<button className="border border-[#193D34] rounded-full font-montserrat font-medium text-[3.2px] h-[8px] text-[#193D34] md:text-[9px] md:h-[26px]">
										Go to Amazon
									</button>
								</div>
							</div>
						</div>

						{/* Card 4 */}
						<div
							className="absolute bg-[#F1F6E9] shadow flex flex-col items-center w-[91px] top-[321.38px] left-[186.1px] pt-[2px] pb-[2px] rounded-[2px]
                                        md:w-[180px] md:top-[350px] md:left-[250px] md:pt-2 md:pb-2"
						>
							<div className="w-[90px] h-[45px] overflow-hidden md:w-[130px] md:h-[70px]">
								<img
									loading="lazy"
									decoding="async"
									src="/assets/home/section5/mobile_card_1.svg"
									alt="Product"
									className="w-full h-full object-cover rounded-t"
								/>
							</div>

							<div className="flex flex-col w-[90px] pt-[1px] pr-[4px] pl-[4px] gap-[3px] md:w-[130px] md:gap-2 md:pt-2 md:px-2">
								<div className="font-montserrat font-medium text-[4px] leading-[6px] md:text-[10px] md:leading-tight text-center">
									Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine
								</div>

								<div className="flex flex-col gap-[1px] md:gap-1 text-center">
									<div className="font-montserrat font-semibold text-[8px] leading-[8px] md:text-[14px] md:leading-[14px]">
										$9.199.999,99 US
									</div>
									<div className="font-montserrat font-semibold text-[3.2px] leading-[6px] text-[#17382F] md:text-[8px] md:leading-[10px]">
										Free Shipping Today!
									</div>
								</div>

								<div className="flex flex-col items-center text-gray-700 mt-1 md:items-start">
									<p className="font-montserrat font-normal text-[3px] leading-[100%] md:text-[7px] md:leading-[10px]">
										Available On
									</p>
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/section5/mobile_amazon.svg"
										alt="amazonLog"
										className="w-[18px] h-[6px] md:w-[40px] md:h-[14px]"
									/>
								</div>

								<div className="flex flex-col gap-1 mt-1 w-full">
									<button className="bg-[#193D34] text-white rounded-full font-montserrat font-medium text-[3.2px] h-[8px] md:text-[9px] md:h-[26px]">
										Compare
									</button>
									<button className="border border-gray-300 rounded-full font-montserrat font-medium text-[3.2px] h-[8px] md:text-[9px] md:h-[26px]">
										View Details
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* 3rd Div – Description positioned at the bottom */}
				<div className="px-4 mt-auto text-center">
					<p className="font-montserrat font-medium text-[18px] leading-[100%] tracking-[0%] text-[#47645D]">
						Make your product sourcing effortless by comparing niche products
						across top suppliers like Amazon, eBay, AliExpress, Walmart and many
						more. Evaluate the best prices, fastest shipping times, stock
						availability and optimum quality to instantly identify the best
						deals, all with minimal effort!
					</p>
				</div>
			</div>

			{/*Section5  End */}

			{/**Section6  */}

			<div className="lg:hidden flex w-full flex-col items-center h-[850px] justify-center relative overflow-hidden top-[4880px]  absolute bg-[#CFE6A2]">
				{/* Title */}
				<div className="w-full text-center text-[#193D34] text-[20px] font-semibold leading-[28px] font-[Montserrat] mb-4">
					Recommended <br /> categories
				</div>

				{/* Carousel Wrapper */}
				<div className="relative w-full flex-row justify-center items-center">
					{/* Navigation Buttons */}
					<button className="custom-prev absolute left-4 top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 transition-opacity duration-300 disabled:opacity-50">
						<ChevronLeft size={20} className="text-white" />
					</button>

					<Swiper
						modules={[Navigation]}
						slidesPerView={1}
						spaceBetween={10}
						loop={true}
						navigation={{ prevEl: ".custom-prev", nextEl: ".custom-next" }}
						className="w-full flex justify-center"
					>
						{categoriesCardRow1.map((card, index) => (
							<SwiperSlide className="flex justify-center">
								<Card variant="categories_mobile" content={card} key={index} />
							</SwiperSlide>
						))}
					</Swiper>

					<button className="custom-next absolute right-4 top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 transition-opacity duration-300 disabled:opacity-50">
						<ChevronRight size={20} className="text-white" />
					</button>
				</div>
				<div className="relative w-full flex-row justify-center items-center mt-3">
					{/* Navigation Buttons */}
					<button className="custom-prev2 absolute left-4 top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 transition-opacity duration-300 disabled:opacity-50">
						<ChevronLeft size={20} className="text-white" />
					</button>

					<Swiper
						modules={[Navigation]}
						slidesPerView={1}
						spaceBetween={10}
						loop={true}
						navigation={{ prevEl: ".custom-prev2", nextEl: ".custom-next2" }}
						className="w-full flex justify-center"
					>
						{categoriesCardRow2.map((card, index) => (
							<SwiperSlide className="flex justify-center">
								<Card variant="categories_mobile" content={card} key={index} />
							</SwiperSlide>
						))}
					</Swiper>

					<button className="custom-next2 absolute right-4 top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 transition-opacity duration-300 disabled:opacity-50">
						<ChevronRight size={20} className="text-white" />
					</button>
				</div>
			</div>

			{/*Section6  End */}

			{/**Section7  */}

			<div className="lg:hidden w-full max-w-[768px] h-[487.999px] absolute top-[6766.73px] left-[-1px] px-[20px] gap-[20px]">
				{/* Title Section */}
				<div className="w-full h-[64px] text-[#193D34] text-[28px] font-semibold leading-[32px] font-[Montserrat] flex flex-col items-center justify-center">
					About Our Successful Customers...
					{/*<button
                        className="mt-2 flex items-center justify-center gap-[2px] w-[104px] h-[32px] rounded-[24px] border border-btnBorderColor p-[8px]"
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 500,
                            fontSize: "13px",
                            lineHeight: "24px",
                            letterSpacing: "0%",
                            color: "#193D34",
                        }}
                    >
                         <div className="w-[70px] h-[16px] flex items-center justify-center text-center">
                            See More
                        </div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-chevron-right"
                        >
                            <path d="m9 18 6-6-6-6" />
                        </svg>
                    </button> */}
				</div>

				{/* Swiper for Mobile */}
				<div className="relative w-full mt-4">
					<Swiper
						modules={[Navigation, Pagination]}
						breakpoints={{
							768: { slidesPerView: 2, spaceBetween: 16 },
						}}
						slidesPerView={1}
						spaceBetween={20}
						pagination={{ clickable: true }}
						className="w-full"
					>
						{homeSection7Cards.map((card, index) => (
							<SwiperSlide>
								<Card variant="homeSection7Mobile" key={index} content={card} />
							</SwiperSlide>
						))}
					</Swiper>
				</div>
				{/* 4th Div - Read More Button */}
				<div className="w-full h-[44px] flex items-center justify-center mt-[24px]">
					<button className="w-full h-[44px] rounded-[24px] bg-[#B7D974] font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34]">
						Read More
					</button>
				</div>
			</div>

			{/*Section7  End */}

			{/**Section8 */}

			<div className="lg:hidden w-full max-w-[768px] h-auto  p-[20px] flex flex-col items-center top-[7350.51px] absolute">
				{/* 1st Div - Blog Heading */}
				<div className="w-full h-auto flex items-center justify-center">
					<div className="text-[#193D34] text-[24px] font-semibold leading-[32px] text-center font-[Montserrat]">
						Blog
					</div>
				</div>

				{/* 2nd Div - Subheading */}
				<div className="w-full h-auto text-[18px] text-[#47645D] font-medium leading-[28px] text-center font-[Montserrat] mt-[16px]">
					Find the best advice and actionable insights on dropshipping in our
					blog section.
				</div>

				{/* 3rd Div - Slider (Swiper) */}
				<div className="w-full h-auto mt-[24px]">
					<Swiper
						modules={[Navigation, Pagination]}
						spaceBetween={12}
						slidesPerView={1.2}
						navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
						pagination={{
							el: ".custom-pagination",
							clickable: true,
							dynamicBullets: true,
						}}
						breakpoints={{
							640: { spaceBetween: 8 },
							480: { spaceBetween: 4 },
							768: { slidesPerView: 2, spaceBetween: 16 },
						}}
						className="w-full"
					>
						{homeSection8MobileCards.map((card, index) => (
							<SwiperSlide>
								<Card variant="homeSection8Mobile" key={index} content={card} />
							</SwiperSlide>
						))}
					</Swiper>
				</div>

				{/* 4th Div - Read More Button */}
				<div className="w-full h-[44px] flex items-center justify-center mt-[24px]">
					<button className="w-full h-[44px] rounded-[24px] bg-[#B7D974] font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34]">
						Read More
					</button>
				</div>
			</div>

			{/*Section8  End */}

			{/**Section9  */}

			<div className="lg:hidden absolute flex flex-col items-center w-full px-4 py-8 top-[8100px] h-[1040px]">
				{/* Heading */}
				<h2 className="text-[#0B1A16] font-montserrat font-semibold text-2xl leading-[28px] text-center mb-6">
					Get started with <br /> these easy steps:
				</h2>

				{/* Steps Container */}
				<div className="flex flex-col gap-6 w-full max-w-[400px]">
					{homeSection9Arr.map((step, index) => (
						<div key={index} className="flex gap-3 w-full items-start">
							{/* Step Number */}
							<div className="min-w-[40px] h-[40px] bg-[#B7D974] rounded-[4px] flex items-center justify-center">
								<div className="text-[#47645D] font-montserrat font-medium text-xl leading-[24px]">
									{step.number}
								</div>
							</div>

							{/* Step Description */}
							<div className="text-[#47645D] font-montserrat font-medium text-sm leading-[20px]">
								{step.text}
							</div>
						</div>
					))}
				</div>
			</div>

			{/*Section9  End */}

			{/**Section10  */}

			<div
				className="absolute w-full h-[569px] top-[8964px] lg:hidden flex items-center justify-center "
				style={{
					backgroundImage: "url('/assets/home/section10/mobile_bag.svg')",
				}}
			>
				{/* Centered Inner Container */}
				<div className="w-[300px] h-[365.82px] flex flex-col items-center justify-center gap-6 mt-4">
					{/* Centered Text Content */}
					<div className="w-full flex-1 flex items-center justify-center">
						<p className="font-montserrat font-semibold italic text-[32px] leading-[40px] text-center text-[#47645D]">
							Gain the Rbetraj advantage! Eliminate time-consuming tasks, reduce
							unwanted errors and stay ahead of the competition.
						</p>
					</div>
				</div>
			</div>

			{/*Section10  End */}

			{/**Section11*/}

			<div className="lg:hidden absolute w-full h-auto top-[9594px] flex flex-col items-center gap-6 px-6 py-8">
				{/* Heading Section */}
				<div className="w-full max-w-[340px] text-center">
					<h2 className="font-montserrat font-semibold text-[32px] leading-none text-center tracking-normal">
						Get started with <br />
						Rbetraj!
						<br /> Dropship Your
						<br /> Way to Success!
					</h2>
				</div>

				{/* Subheading Section */}
				<div className="w-full max-w-[320px] text-center">
					<p className="font-montserrat font-medium text-[14px] leading-[20px] text-[#47645D]">
						Sign up for our Dropshipping Automation Software today, simplify the
						process of finding top products and scale your online store with
						ease. Become an experienced seller!
					</p>
				</div>
				<Link to="/sign-up">
					<button className="w-[212px] h-[44px] rounded-[24px] bg-[#193D34] text-white font-[Montserrat] font-medium text-[13px] leading-[24px] tracking-[0%] text-center flex items-center justify-center mt-2">
						Create Account
					</button>
				</Link>
			</div>

			{/*Section11  End */}

			{/**Section12 */}

			<div className="lg:hidden absolute w-full h-[500px] top-[10072px] px-6 gap-8 flex flex-col items-center">
				{/* Header Section */}
				<div className="w-full flex flex-col items-center gap-2">
					<h2 className="text-2xl font-semibold text-[#17382F] text-center font-[Montserrat]">
						FAQ
					</h2>
					<p className="text-base font-normal text-[#193D34] text-center font-[Montserrat] leading-[22px]">
						Have questions? Find quick, helpful answers to help you get started
						with Rbetraj.
					</p>
				</div>

				{/* Carousel Container */}
				<div className="w-full relative h-[300px]">
					<Swiper
						slidesPerView={1.2}
						centeredSlides={true}
						spaceBetween={16}
						className="h-full"
						breakpoints={{
							375: { slidesPerView: 1.3 },
							480: { slidesPerView: 1.4 },
							768: { slidesPerView: 2.2 },
						}}
					>
						{[1, 2, 3, 4, 5, 6].map((item, index) => (
							<SwiperSlide key={index} className="h-full">
								<div className="w-full h-full flex items-center justify-center">
									<Card
										variant="faq"
										content={{
											icon: "/assets/home/section11/faq.png",
											category: "FAQ",
											question: "Which are the best Dropshipping suppliers?",
											answerPreview:
												"There are many trustworthy and reliable suppliers in the market...",
											readTimeIcon: "/assets/home/section11/clock.png",
											readTime: "9 minutes",
											backgroundColor:
												index === 5 ? "bg-[#657D77]" : "bg-[#D2DCD1]",
											textColor: index === 5 ? "#ffffff" : undefined,
										}}
										className="w-[240px] h-[225px] rounded-[8px] transform transition-transform scale-100"
									/>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>

				{/* Read More Button */}
				<div className="w-[167px] h-[44px] flex items-center justify-center rounded-[24px] bg-[#B7D974]">
					<button className="text-[#193D34] font-[Montserrat] font-medium text-[13px]">
						Read More
					</button>
				</div>
			</div>

			{/*Section12  End */}

			<Footer desktop="top-[10410px]" mobile="top-[11581px]" />
		</>
	);
};

export default Home;
